import api from '../api';
import { ProductsEndpoints } from './constants';
import { MyProductProgress, PaywallProductProps, PurchasedResponse, SalesResponse } from './types';

export const getProductsPaywall = async (
  membershipSlug: string,
  communityId: number
): Promise<PaywallProductProps[] | []> => {
  const url = ProductsEndpoints.getProductsPaywall(membershipSlug, communityId);
  const { data } = await api.get(url);

  return data;
};

export const getProductsPaywallPublic = async (
  membershipSlug: string,
  communityId: number
): Promise<PaywallProductProps[] | []> => {
  const url = ProductsEndpoints.getProductsPaywallPublic(membershipSlug, communityId);
  const { data } = await api.get(url);

  return data;
};

export const getSaleProducts = async (membershipSlug: string): Promise<SalesResponse> => {
  const url = ProductsEndpoints.getSaleProducts(membershipSlug);
  const { data } = await api.get(url);

  return data;
};

export const getPurchasedProducts = async (membershipSlug: string): Promise<PurchasedResponse> => {
  const url = ProductsEndpoints.getPurchasedProducts(membershipSlug);
  const { data } = await api.get(url);

  return data;
};

export const getMyProductsProgress = async (ucode?: string): Promise<MyProductProgress[]> => {
  const url = ProductsEndpoints.getMyProductsProgress(ucode);
  const { data } = await api.get(url);

  return data;
};
